import React from 'react';
import PropTypes from 'prop-types';
import { JsonLdScript } from 'components/atoms';

const PRODUCTION_BASE_URL = 'https://www.selfstorage.com';

export function WebPageSchema({ facility, baseUrl }) {
	const rootUrl = baseUrl || PRODUCTION_BASE_URL;

	const webPageSchema = {
		'@context': 'https://schema.org',
		'@type': 'WebPage',
		name: facility?.name
			? `${facility.name} | SelfStorage.com`
			: 'SelfStorage.com',
		url: `${rootUrl}${facility?.url || ''}`,
		description: facility?.name
			? `Get the best rate on self storage at ${facility.name}. Compare prices, read verified reviews, and easily reserve online with SelfStorage.com.`
			: 'Get the best rate on self storage. Compare prices, read verified reviews, and easily reserve online with SelfStorage.com.',
		isPartOf: {
			'@type': 'WebSite',
			'@id': 'https://www.selfstorage.com/',
		},
	};

	return <JsonLdScript schema={webPageSchema} />;
}

WebPageSchema.propTypes = {
	facility: PropTypes.object,
	baseUrl: PropTypes.string,
};

export default WebPageSchema;
